import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=80f671fc&scoped=true&"
import script from "./BulkActions.vue?vue&type=script&lang=js&"
export * from "./BulkActions.vue?vue&type=script&lang=js&"
import style0 from "./BulkActions.vue?vue&type=style&index=0&id=80f671fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f671fc",
  null
  
)

export default component.exports